import { UPDATE_VERSIONS } from './constants'

// Initial state of the store
const initialState = {
    dev: undefined,
    release: undefined,
}

// Commands for the state machine
const sync = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_VERSIONS:
            return action.payload

        // Default state
        default:
            return state
    }
}

export default sync



// WEBPACK FOOTER //
// ./src/features/Sync/data/versions/reducer.js